import React from 'react';
import {createStyles, makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
    createStyles({
        iosImage: {
            width: 18,
        },
    }));

export default function IosShareIcon(): JSX.Element {
    const classes = useStyles();
    return <img
        alt={'Share'}
        className={classes.iosImage}
        src={'/ios-share.png'}
    />;
}